import { PanelRightClose } from "lucide-react";

export let routes = [

  // organization
  { name: "/organization/switcher", action: "ORGANIZATION_ALL||Switch_Organization" },
  { name: "/organization/details", action: "ORGANIZATION_ALL||Switch_Organization" },
  { name: "/organization/profile", action: "ORGANIZATION_PROFILE_ALL" },
  { name: "/organization/application-access", action: "VIEW_ORGANIZATION_APPLICATION" },

  // employees
  { name: "/organization/employee/employee-details", action: "EMPLOYEE_VIEW_ALL" },
  { name: "/organization/employee/employee-details/add", action: "EMPLOYEE_ADD" },
  { name: "/organization/employee/employee-details/edit", action: "EMPLOYEE_EDIT" },




  // employee exits 
  { name: "/training-programs", action: "VIEW_TRAINING_PROGRAMS" },
  { name: "/training-programs/add", action: "ADD_TRAINING_PROGRAM" },
  { name: "/training-programs/edit", action: "EDIT_TRAINING_PROGRAM" },
  { name: "/training-programs/view", action: "VIEW_TRAINING_PROGRAM" },
  { name: "/training-programs/delete", action: "DELETE_TRAINING_PROGRAM" },

  { name: "/program-monthly-traffic", action: "VIEW_PROGRAM_MONTHLY_TRAFFIC" },
  { name: "/program-monthly-traffic/add", action: "ADD_PROGRAM_MONTHLY_TRAFFIC" },
  { name: "/program-monthly-traffic/edit", action: "EDIT_PROGRAM_MONTHLY_TRAFFIC" },
  { name: "/program-monthly-traffic/view", action: "VIEW_PROGRAM_MONTHLY_TRAFFIC" },
  { name: "/program-monthly-traffic/delete", action: "DELETE_PROGRAM_MONTHLY_TRAFFIC" },

// employee records
  { name: "/training-programs-categories", action: "VIEW_TRAINING_PROGRAM_CATEGORIES" },
  { name: "/training-programs-categories/add", action: "ADD_TRAINING_PROGRAM_CATEGORY" },
  { name: "/training-programs-categories/edit", action: "EDIT_TRAINING_PROGRAM_CATEGORY" },
  { name: "/training-programs-categories/view", action: "VIEW_TRAINING_PROGRAM_CATEGORIES" },
  { name: "/training-programs-categories/delete", action: "DELETE_TRAINING_PROGRAM_CATEGORY" },

  { name: "/training-program-modules", action: "VIEW_TRAINING_PROGRAM_MODULES||VIEW_SELF_TRAINING_PROGRAM_MODULES" },
  { name: "/training-program-modules/add", action: "ADD_TRAINING_PROGRAM_MODULE" },
  { name: "/training-program-modules/edit", action: "EDIT_TRAINING_PROGRAM_MODULE" },
  { name: "/training-program-modules/view", action: "VIEW_TRAINING_PROGRAM_MODULES" },
  { name: "/training-program-modules/delete", action: "DELETE_TRAINING_PROGRAM_MODULE" },

  { name: "/module-questions", action: "VIEW_MODULE_QUESTIONS||VIEW_SELF_MODULE_QUESTIONS" },
  { name: "/module-questions/add", action: "ADD_MODULE_QUESTION" },
  { name: "/module-questions/edit", action: "EDIT_MODULE_QUESTION" },
  { name: "/module-questions/view", action: "VIEW_MODULE_QUESTIONS" },
  { name: "/module-questions/delete", action: "DELETE_MODULE_QUESTION" },

  { name: "/offers", action: "VIEW_OFFERS" },
  { name: "/offers/add", action: "ADD_OFFER" },
  { name: "/offers/edit", action: "EDIT_OFFER" },
  { name: "/offers/view", action: "VIEW_OFFERS" },
  { name: "/offers/delete", action: "DELETE_OFFER" },

  { name: "/offer-audiences", action: "VIEW_OFFER_AUDIENCES" },
  { name: "/offer-audiences/add", action: "ADD_OFFER_AUDIENCE" },
  { name: "/offer-audiences/edit", action: "EDIT_OFFER_AUDIENCE" },
  { name: "/offer-audiences/view", action: "VIEW_OFFER_AUDIENCES" },
  { name: "/offer-audiences/delete", action: "DELETE_OFFER_AUDIENCE" },

  { name: "/offer-redemptions", action: "VIEW_OFFER_REDEMPTIONS" },

  { name: "/training-spaces", action: "VIEW_TRAINING_SPACES" },
  { name: "/training-spaces/add", action: "ADD_TRAINING_SPACES" },
  { name: "/training-spaces/edit", action: "EDIT_TRAINING_SPACES" },
  { name: "/training-spaces/view", action: "VIEW_TRAINING_SPACES" },
  { name: "/training-spaces/delete", action: "DELETE_TRAINING_SPACES" },
  { name: "/slot-availability", action: "VIEW_SLOT_AVALABILITY" },
  { name: "/trainer-slot-availability", action: "VIEW_TRAINER_SLOT_AVALABILITY" },

// functional role 
  { name: "/students", action: "VIEW_STUDENTS" },
  { name: "/students/add", action: "ADD_STUDENT" },
  { name: "/students/edit", action: "EDIT_STUDENT" },
  { name: "/students/view", action: "VIEW_STUDENTS" },
  { name: "/students/delete", action: "DELETE_STUDENT" },

  // employment stages 
  { name: "/students-fees", action: "VIEW_STUDENT_FEE||VIEW_ASSIGNED_STUDENT_FEE" },
  { name: "/students-fees/add", action: "ADD_STUDENT_FEE" },
  { name: "/students-fees/edit", action: "EDIT_STUDENT_FEE" },
  { name: "/students-fees/view", action: "VIEW_STUDENT_FEE||VIEW_ASSIGNED_STUDENT_FEE" },
  { name: "/students-fees/delete", action: "DELETE_STUDENT_FEE" },

// document types
  { name: "/leads", action: "VIEW_LEADS||VIEW_ASSIGNED_LEADS" },
  { name: "/leads/add", action: "ADD_LEAD" },
  { name: "/leads/edit", action: "EDIT_LEAD" },
  { name: "/leads/view", action: "VIEW_LEADS||VIEW_ASSIGNED_LEADS" },
  { name: "/leads/delete", action: "DELETE_LEAD" },

// document 
  { name: "/lead-stages", action: "VIEW_LEAD_STAGE" },
  { name: "/lead-stages/add", action: "ADD_LEAD_STAGE" },
  { name: "/lead-stages/edit", action: "EDIT_LEAD_STAGE" },
  { name: "/lead-stages/view", action: "VIEW_LEAD_STAGE" },
  { name: "/lead-stages/delete", action: "DELETE_LEAD_STAGE" },

  // skills category
  { name: "/lead-sources", action: "VIEW_LEAD_SOURCE" },
  { name: "/lead-sources/add", action: "ADD_LEAD_SOURCE" },
  { name: "/lead-sources/edit", action: "EDIT_LEAD_SOURCE" },
  { name: "/lead-sources/view", action: "VIEW_LEAD_SOURCE" },
  { name: "/lead-sources/delete", action: "DELETE_LEAD_SOURCE" },

  // skills category group
  { name: "/lead-activities", action: "VIEW_LEAD_ACTIVITY||VIEW_ASSIGNED_LEAD_ACTIVITY" },
  { name: "/lead-activities/add", action: "ADD_LEAD_ACTIVITY" },
  { name: "/lead-activities/edit", action: "EDIT_LEAD_ACTIVITY" },
  { name: "/lead-activities/view", action: "VIEW_LEAD_ACTIVITY||VIEW_ASSIGNED_LEAD_ACTIVITY" },
  { name: "/lead-activities/delete", action: "DELETE-LEAD_ACTIVITY" },

  { name: "/lead-activity-report", action: "VIEW_LEAD_ACTIVITY_REPORT" },
  { name: "/counsellor-report", action: "VIEW_COUNSELLOR_REPORT" },
  { name: "/followup-structures", action: "VIEW_FOLLOWUP_STRUCTURES" },
  { name: "/followup-structures/add", action: "ADD_FOLLOWUP_STRUCTURE" },
  { name: "/followup-structures/edit", action: "EDIT_FOLLOWUP_STRUCTURE" },
  { name: "/followup-structures/view", action: "VIEW_FOLLOWUP_STRUCTURES" },
  { name: "/followup-structures/delete", action: "DELETE_FOLLOWUP_STRUCTURE" },

  // functional role skill
  { name: "/lead-contact-timings", action: "VIEW_LEAD_CONTACT_TIMINGS" },
  { name: "/lead-contact-timings/add", action: "ADD_LEAD_CONTACT_TIMING" },
  { name: "/lead-contact-timings/edit", action: "EDIT_LEAD_CONTACT_TIMING" },
  { name: "/lead-contact-timings/view", action: "VIEW_LEAD_CONTACT_TIMINGS" },
  { name: "/lead-contact-timings/delete", action: "DELETE_CONTACT_TIMING" },



  
  // functional role skill element
  { name: "/assesments", action: "VIEW_ASSESSMENTS||VIEW_SELF_ASSESSMENTS" },
  { name: "/assesments/add", action: "ADD_ASSESSMENT" },
  { name: "/assesments/edit", action: "EDIT_ASSESSMENT" },
  { name: "/assesments/view", action: "VIEW_ASSESSMENTS" },
  { name: "/assesments/delete", action: "DELETE_ASSESSMENT" },

  { name: "/assessment-types", action: "VIEW_ASSESSMENT_TYPES" },
  { name: "/assessment-types/add", action: "ADD_ASSESSMENT_TYPE" },
  { name: "/assessment-types/edit", action: "EDIT_ASSESSMENT_TYPE" },
  { name: "/assessment-types/view", action: "VIEW_ASSESSMENT_TYPES" },
  { name: "/assessment-types/delete", action: "DELETE_ASSESSMENT_TYPE" },

  { name: "/assessment-tests", action: "VIEW_ASSESSMENT_TESTS||VIEW_SELF_ASSESSMENT_TESTS" },
  { name: "/assessment-tests/add", action: "ADD_ASSESSMENT_TEST" },
  { name: "/assessment-tests/edit", action: "EDIT_ASSESSMENT_TEST" },
  { name: "/assessment-tests/view", action: "VIEW_ASSESSMENT_TESTS" },
  { name: "/assessment-tests/delete", action: "DELETE_ASSESSMENT_TEST" },

  { name: "/assessment-schedules", action: "VIEW_ASSESSMENT_SCHEDULES||VIEW_SELF_ASSESSMENT_SCHEDULES" },
  { name: "/assessment-schedules/add", action: "ADD_ASSESSMENT_SCHEDULE" },
  { name: "/assessment-schedules/edit", action: "EDIT_ASSESSMENT_SCHEDULE" },
  { name: "/assessment-schedules/view", action: "VIEW_ASSESSMENT_SCHEDULES" },
  { name: "/assessment-schedules/delete", action: "DELETE_ASSESSMENT_SCHEDULE" },

  // works shifts 
  { name: "/assesment-results", action: "VIEW_ASSESSMENT_RESULTS||VIEW_SELF_ASSESSMENT_RESULTS" },
  { name: "/assesment-results/add", action: "ADD_ASSESSMENT_RESULT" },
  { name: "/assesment-results/edit", action: "EDIT_ASSESSMENT_RESULT" },
  { name: "/assesment-results/view", action: "VIEW_ASSESSMENT_RESULTS" },
  { name: "/assesment-results/delete", action: "DELETE_ASSESSMENT_RESULT" },

// WORKSHIFT DAYS 
  { name: "/batches", action: "VIEW_BATCHES||VIEW_SELF_BATCHES" },
  { name: "/student-batch-calendar", action: "VIEW_BATCHES||VIEW_SELF_BATCHES" },
  { name: "/batches/add", action: "ADD_BATCHES" },
  { name: "/batches/edit", action: "EDIT_BATCHES" },
  { name: "/batches/view", action: "VIEW_BATCHES||VIEW_SELF_BATCHES" },
  { name: "/batches/delete", action: "DELETE_BATCHES" },

  { name: "/batch-modules", action: "VIEW_BATCHES||VIEW_SELF_BATCHES" },
  { name: "/batch-modules/edit", action: "EDIT_BATCHES" },
  { name: "/batch-modules/view", action: "VIEW_BATCHES||VIEW_SELF_BATCHES" },
  { name: "/batch-modules/delete", action: "DELETE_BATCH_MODULE" },

  { name: "/batch-trainer-modules", action: "VIEW_BATCHES||VIEW_SELF_BATCHES" },
  { name: "/batch-class-trainers", action: "VIEW_BATCH_CLASS||VIEW_SELF_BATCH_CLASSES" },
  { name: "/batch-class-record-trainers", action: "VIEW_BATCH_CLASS_RECORD||VIEW_SELF_BATCH_CLASS_RECORDS" },

  // batch trainers
  { name: "/batch-trainers", action: "VIEW_BATCHES" },
  { name: "/batch-trainers/add", action: "ADD_BATCHES" },
  { name: "/batch-trainers/edit", action: "EDIT_BATCHES" },
  { name: "/batch-trainers/view", action: "VIEW_BATCHES" },
  { name: "/batch-trainers/delete", action: "DELETE_BATCHES" },

  // work model days 
  { name: "/batch-classes", action: "VIEW_BATCH_CLASS||VIEW_SELF_BATCH_CLASSES" },
  { name: "/batch-classes/add", action: "ADD_BATCH_CLASS" },
  { name: "/batch-classes/edit", action: "EDIT_BATCH_CLASS" },
  { name: "/batch-classes/view", action: "VIEW_BATCH_CLASS||VIEW_SELF_BATCH_CLASSES" },
  { name: "/batch-classes/delete", action: "DELETE_BATCH_CLASS" },

  { name: "/class-records", action: "VIEW_BATCH_CLASS_RECORD||VIEW_SELF_BATCH_CLASS_RECORDS" },
  { name: "/class-records/add", action: "ADD_BATCH_CLASS_RECORD" },
  { name: "/class-records/edit", action: "EDIT_BATCH_CLASS_RECORD" },
  { name: "/class-records/view", action: "VIEW_BATCH_CLASS_RECORD||VIEW_SELF_BATCH_CLASS_RECORDS" },
  { name: "/class-records/delete", action: "DELETE_BATCH_CLASS_RECORD" },

  // workshift assignments 
  { name: "/batch-students", action: "VIEW_BATCH_STUDENTS||VIEW_SELF_BATCH_STUDENTS" },
  { name: "/batch-students/add", action: "ADD_BATCH_STUDENT" },
  { name: "/batch-students/edit", action: "EDIT_BATCH_STUDENTS" },
  { name: "/batch-students/view", action: "VIEW_BATCH_STUDENTS||VIEW_SELF_BATCH_STUDENTS" },
  { name: "/batch-students/delete", action: "DELETE_BATCH_STUDENTS" },

  // rotation days
  { name: "/recruitment-agencies", action: "VIEW_RECRUITMENT_AGENCIES||ADD_RECRUITMENT_AGENCIES||EDIT_RECRUITMENT_AGENCIES||DELETE_RECRUITMENT_AGENCIES" },
  { name: "/recruitment-agencies/add", action: "ADD_RECRUITMENT_AGENCIES" },
  { name: "/recruitment-agencies/edit", action: "EDIT_RECRUITMENT_AGENCIES" },
  { name: "/recruitment-agencies/view", action: "VIEW_RECRUITMENT_AGENCIES||EDIT_RECRUITMENT_AGENCIES" },
  { name: "/recruitment-agencies/delete", action: "DELETE_RECRUITMENT_AGENCIES" },

  // shift rotation assignment
  { name: "/companies", action: "VIEW_COMPANIES||ADD_COMPANIES||EDIT_COMPANIES||DELETE_COMPANIES" },
  { name: "/companies/add", action: "ADD_COMPANIES" },
  { name: "/companies/edit", action: "EDIT_COMPANIES" },
  { name: "/companies/view", action: "VIEW_COMPANIES||EDIT_COMPANIES" },
  { name: "/companies/delete", action: "DELETE_COMPANIES" },

  // attendance time logs
  { name: "/admissions", action: "VIEW_ADMISSIONS" },
  { name: "/admissions/add", action: "ADD_ADMISSION" },
  { name: "/admissions/edit", action: "EDIT_ADMISSION" },
  { name: "/admissions/view", action: "VIEW_ADMISSIONS" },
  { name: "/admissions/delete", action: "DELETE_ADMISSION" },

  // attendance records
  { name: "/fee-installments", action: "VIEW_FEE_INSTALLMENTS||VIEW_ASSIGNED_STUDENT_FEE" },
  { name: "/fee-installments/add", action: "ADD_FEE_INSTALLMENT" },
  { name: "/fee-installments/edit", action: "EDIT_FEE_INSTALLMENT" },
  { name: "/fee-installments/view", action: "VIEW_FEE_INSTALLMENTS||VIEW_ASSIGNED_STUDENT_FEE" },
  { name: "/fee-installments/delete", action: "DELETE_FEE_INSTALLMENT" },
  { name: "/fee-due-report", action: "FEE_DUE_REPORT||VIEW_ASSIGNED_STUDENT_FEE" },

  // holiday calendar
  { name: "/classes-attendance", action: "VIEW_CLASS_ATTENDANCES||VIEW_SELF_CLASS_ATTENDANCE" },
  { name: "/classes-attendance/add", action: "ADD_CLASS_ATTENDANCE" },
  { name: "/classes-attendance/edit", action: "EDIT_CLASS_ATTENDANCE" },
  { name: "/classes-attendance/view", action: "VIEW_CLASS_ATTENDANCES||VIEW_SELF_CLASS_ATTENDANCE" },
  { name: "/classes-attendance/delete", action: "DELETE_CLASS_ATTENDANCE" },
  { name: "/attendance-report", action: "VIEW_CLASS_ATTENDANCES||VIEW_SELF_CLASS_ATTENDANCE" },

  // employee leaves 
  { name: "/placement-referrals", action: "VIEW_PLACEMENT_REFERRALS||ADD_PLACEMENT_REFERRAL||EDIT_PLACEMENT_REFERRAL||DELETE_PLACEMENT_REFERRAL" },
  { name: "/placement-referrals/add", action: "ADD_PLACEMENT_REFERRAL" },
  { name: "/placement-referrals/edit", action: "EDIT_PLACEMENT_REFERRAL" },
  { name: "/placement-referrals/view", action: "VIEW_PLACEMENT_REFERRALS||EDIT_PLACEMENT_REFERRAL" },
  { name: "/placement-referrals/delete", action: "DELETE_PLACEMENT_REFERRAL" },

  { name: "/placement-assistance", action: "VIEW_PLACEMENT_ASSISTANCE" },
  { name: "/placement-assistance/add", action: "ADD_PLACEMENT_ASSISTANCE" },
  { name: "/placement-assistance/edit", action: "EDIT_PLACEMENT_ASSISTANCE" },
  { name: "/placement-assistance/view", action: "VIEW_PLACEMENT_ASSISTANCE" },
  { name: "/placement-assistance/delete", action: "DELETE_PLACEMENT_ASSISTANCE" },

  { name: "/placement-mock-interviews", action: "VIEW_PLACEMENT_MOCK_INTERVIEWS" },
  { name: "/placement-mock-interviews/add", action: "ADD_PLACEMENT_MOCK_INTERVIEW" },
  { name: "/placement-mock-interviews/edit", action: "EDIT_PLACEMENT_MOCK_INTERVIEW" },
  { name: "/placement-mock-interviews/view", action: "VIEW_PLACEMENT_MOCK_INTERVIEWS" },
  { name: "/placement-mock-interviews/delete", action: "DELETE_PLACEMENT_MOCK_INTERVIEW" },

  { name: "/placement-pool", action: "VIEW_COMPANIES||ADD_COMPANIES||EDIT_COMPANIES||DELETE_COMPANIES||VIEW_PLACEMENT_REFERRALS||ADD_PLACEMENT_REFERRAL||EDIT_PLACEMENT_REFERRAL||DELETE_PLACEMENT_REFERRAL||VIEW_RECRUITMENT_AGENCIES||ADD_RECRUITMENT_AGENCIES||EDIT_RECRUITMENT_AGENCIES||DELETE_RECRUITMENT_AGENCIES" },

  { name: "/student-review-platforms", action: "VIEW_REVIEW_PLATFORM||VIEW_STUDENT_REVIEW_PLATFORMS" },
  { name: "/student-review-platforms/add", action: "ADD_REVIEW_PLATFORM||ADD_STUDENT_REVIEW_PLATFORM" },
  { name: "/student-review-platforms/edit", action: "EDIT_REVIEW_PLATFROM||EDIT_REVIEW_PLATFORM||EDIT_STUDENT_REVIEW_PLATFORM" },
  { name: "/student-review-platforms/view", action: "VIEW_REVIEW_PLATFORM||VIEW_STUDENT_REVIEW_PLATFORMS" },
  { name: "/student-review-platforms/delete", action: "DELETE_REVIEW_PLATFROM||DELETE_REVIEW_PLATFORM||DELETE_STUDENT_REVIEW_PLATFORM" },

  { name: "/student-reviews", action: "VIEW_STUDENT_REVIEW||VIEW_STUDENT_REVIEWS" },
  { name: "/student-reviews/add", action: "ADD_STUDENT_REVIEW" },
  { name: "/student-reviews/edit", action: "EDIT_STUDENT_REVIEW" },
  { name: "/student-reviews/view", action: "VIEW_STUDENT_REVIEW||VIEW_STUDENT_REVIEWS" },
  { name: "/student-reviews/delete", action: "DELETE_STUDENT_REVIEW" },

  // employee entitlments
  { name: "/demo-sessions", action: "VIEW_DEMO_SESSIONS||VIEW_SELF_DEMO_SESSIONS" },
  { name: "/demo-sessions/add", action: "ADD_DEMO_SESSION" },
  { name: "/demo-sessions/edit", action: "EDIT_DEMO_SESSION" },
  { name: "/demo-sessions/view", action: "VIEW_DEMO_SESSIONS||VIEW_SELF_DEMO_SESSIONS" },
  { name: "/demo-sessions/delete", action: "DELETE_DEMO_SESSION" },

  { name: "/demo-participants", action: "VIEW_DEMO_PARTICIPANTS||VIEW_SELF_DEMO_PARTICIPANTS" },
  { name: "/demo-participants/add", action: "ADD_DEMO_PARTICIPANTS" },
  { name: "/demo-participants/edit", action: "EDIT_DEMO_PARTICIPANTS" },
  { name: "/demo-participants/view", action: "VIEW_DEMO_PARTICIPANTS||VIEW_SELF_DEMO_PARTICIPANTS" },
  { name: "/demo-participants/delete", action: "DELETE_DEMO_PARTICIPANTS" },

// copy  employee 
  { name: "/certificates", action: "VIEW_CERTIFICATES" },
  { name: "/certificates/add", action: "ADD_CERTIFICATE" },
  { name: "/certificates/edit", action: "EDIT_CERTIFICATE" },
  { name: "/certificates/view", action: "VIEW_CERTIFICATES" },
  { name: "/certificates/delete", action: "DELETE_CERTIFICATE" },

  // student portal
  { name: "/student/profile", action: "VIEW_SELF_STUDENT_PROFILE" },
  { name: "/student/fees", action: "VIEW_SELF_STUDENT_FEES" },
  { name: "/student/courses", action: "VIEW_SELF_STUDENT_COURSES" },
  { name: "/student/catalog", action: "VIEW_SELF_STUDENT_CATALOG" },

 
  // change password

  { name: "/settings/change-password", action: "USER_RESET_PASSWORD" },
  { name: "/application/activity-logs", action: "VIEW_ACTIVITY_LOGS" },
  { name: "/application/email-logs", action: "VIEW_EMAIL_LOGS" },

  { name: "/users", action: "USER_VIEW_ALL" },
  { name: "/users/add", action: "USER_VIEW_ALL" },
  { name: "/users/edit", action: "USER_VIEW_ALL" },
  { name: "/users/view", action: "USER_VIEW_ALL" },
  { name: "/application/user-roles", action: "USER_ROLE_ALL" },
  { name: "/application/user-role-permission", action: "USER_ROLE_PERMISSION_ALL" },
  { name: "/application/user-permission", action: "USER_PERMISSION_ALL" },
  { name: "/billing", action: "BILLING_ALL" },
  { name: "/billing/plans", action: "BILLING_ALL" },

];

/**
 * True if user Permission array includes the action (supports "A||B" in route config).
 */
export function checkPermission(permissionList, action) {
  if (permissionList == null || !Array.isArray(permissionList) || !action) {
    return false;
  }
  const tokens = String(action)
    .split("||")
    .map((x) => String(x).trim().toUpperCase())
    .filter(Boolean);
  if (!tokens.length) return false;
  return tokens.some((token) =>
    permissionList.some((p) => String(p).trim().toUpperCase() === token)
  );
}

/**
 * Get permission action names for a module (list/form) by base path.
 * Use with usePermissionDataStore: Permission.includes(actions.add) etc.
 *
 * list: action required to see the list page (e.g. VIEW_LEADS). Used as fallback
 *       for View button so "can see list" => can open view single record.
 * Delete: If a "/delete" route exists (e.g. DELETE_LEAD), the Delete button
 * is shown only when the backend returns that action. If no "/delete" route
 * is defined, delete falls back to the edit action (can edit = can delete).
 *
 * @param {string} basePath - e.g. "/leads", "/lead-stages"
 * @returns {{ add?: string, edit?: string, view?: string, delete?: string, list?: string }}
 */
export function getModuleActions(basePath) {
  if (!basePath) return {};
  const normalized = basePath.replace(/\/$/, "");
  const list = routes.find((r) => r.name === normalized)?.action;
  const add = routes.find((r) => r.name === `${normalized}/add`)?.action;
  const edit = routes.find((r) => r.name === `${normalized}/edit`)?.action;
  const view = routes.find((r) => r.name === `${normalized}/view`)?.action;
  const del = routes.find((r) => r.name === `${normalized}/delete`)?.action;
  const hasDeleteRoute = routes.some((r) => r.name === `${normalized}/delete`);
  return {
    list,
    add,
    edit,
    view,
    // Modules with an explicit /delete route require that permission only (e.g. DELETE_DEMO_SESSION).
    delete: hasDeleteRoute ? del : del || edit,
  };
}
